module.exports = __webpack_public_path__ + "static/img/1426344.1e872cbc.png";